import DomUtil from '@/utils/DomUtil';
import StorageUtil from "@/utils/StorageUtil";
import Config from "@/config";
import { closeToast, showConfirmDialog, showLoadingToast, showSuccessToast } from "vant";
const __default__ = {
  data() {
    return {
      pageWidth: window.innerWidth + "px",
      pageHeight: window.innerHeight + "px"
    };
  },
  mounted() {
    this.resizePage();
    window.onresize = () => {
      return (() => {
        this.$nextTick(() => {
          this.resizePage();
        });
      })();
    };
    this.checkLocalUpdate();
  },
  methods: {
    resizePage() {
      const pageSize = DomUtil.getBrowserInterfaceSize();
      this.pageWidth = pageSize.pageWidth + "px";
      this.pageHeight = pageSize.pageHeight + "px";
    },
    checkLocalUpdate() {
      // if (!StorageUtil.contains("_router_util_vue_router_data")) {
      if (StorageUtil.contains("_router_util_vue_router_data")) {
        let needUpdate = false;
        if (!StorageUtil.contains("updated")) {
          needUpdate = true;
        }
        if (!needUpdate && StorageUtil.contains("updated")) {
          if (StorageUtil.contains("version") && StorageUtil.containsObjectAttr("version", "versionCode")) {
            const versionCode = StorageUtil.getObjectAttr("version", "versionCode");
            // if (versionCode < Config.versionCode) {
            if (versionCode !== Config.versionCode) {
              needUpdate = true;
            }
          } else {
            needUpdate = true;
          }
        }
        if (needUpdate) {
          if (Config.versionUpdateMode === "manual") {
            showConfirmDialog({
              title: "程序更新",
              message: "当前程序版本已经升级，请进行本地更新。",
              cancelButtonDisabled: true,
              confirmButtonText: "开始更新"
            }).then(() => {
              showLoadingToast({
                duration: 0,
                // overlay: true,
                forbidClick: true,
                message: '升级处理中...'
              });
              setTimeout(function () {
                closeToast();
                StorageUtil.clearCache();
                StorageUtil.set("updated", new Date().getTime());
                StorageUtil.setObjectAttr("version", "versionCode", Config.versionCode);
                StorageUtil.setObjectAttr("version", "versionName", Config.versionName);
                showSuccessToast("本地升级完成");
              }, 1600);
            }).catch(() => {
              // on cancel
            });
          } else {
            StorageUtil.clearCache();
            StorageUtil.set("updated", new Date().getTime());
            StorageUtil.setObjectAttr("version", "versionCode", Config.versionCode);
            StorageUtil.setObjectAttr("version", "versionName", Config.versionName);
          }
        }
      } else {
        StorageUtil.setObjectAttr("version", "versionCode", Config.versionCode);
        StorageUtil.setObjectAttr("version", "versionName", Config.versionName);
      }
    }
  }
};
import { useCssVars as _useCssVars } from 'vue';
const __injectCSSVars__ = () => {
  _useCssVars(_ctx => ({
    "7ac079cc": _ctx.pageWidth,
    "7900743e": _ctx.pageHeight
  }));
};
const __setup__ = __default__.setup;
__default__.setup = __setup__ ? (props, ctx) => {
  __injectCSSVars__();
  return __setup__(props, ctx);
} : __injectCSSVars__;
export default __default__;